
export default {
  props: {
    demandInfo: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    var _this = this;

    var h = this.$createElement;

    return {
      formConfig: {},
      formValue: {
        id: '',
        instruction: ''
      },
      formItemList: [{
        label: '需求ID：',
        type: 'plain-text',
        prop: 'id'
      }, {
        label: '需求说明：',
        prop: 'instruction',
        component: {
          functional: true,
          render: function render(h, context) {
            if (_this.demandInfo.material_source === 3) {
              var _list = (context.props.formValue.instruction || '').split('\n');
              return _list.map(function (item) {
                var listItem = item.split('：');
                return h(
                  'div',
                  { style: 'margin-bottom: 10px; overflow: hidden;' },
                  [h(
                    'strong',
                    null,
                    [listItem[0], '\uFF1A']
                  ), h(
                    'a',
                    {
                      attrs: { target: '_blank', href: listItem[1] }
                    },
                    [listItem[1]]
                  )]
                );
              });
            }

            var list = (context.props.formValue.instruction || '').split('\n');
            return list.map(function (item) {
              return h(
                'div',
                { style: 'margin-bottom: 10px; word-break:break-all;' },
                [item]
              );
            });
          }
        }
      }]
    };
  },

  watch: {
    demandInfo: function demandInfo() {
      this.fillFormValue();
    }
  },
  methods: {
    fillFormValue: function fillFormValue() {
      this.formValue.id = this.demandInfo.id;
      this.formValue.instruction = this.demandInfo.instruction;
    }
  },
  mounted: function mounted() {
    this.fillFormValue();
  }
};